export const MakeAnAdminIcon = () => {
	return (
		<svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M12.5244 14.2355H5.47442C5.15942 14.2355 4.80692 13.988 4.70192 13.688L1.59692 5.00301C1.15442 3.75801 1.67192 3.37551 2.73692 4.14051L5.66192 6.23301C6.14942 6.57051 6.70442 6.39801 6.91442 5.85051L8.23442 2.33301C8.65442 1.20801 9.35192 1.20801 9.77192 2.33301L11.0919 5.85051C11.3019 6.39801 11.8569 6.57051 12.3369 6.23301L15.0819 4.27551C16.2519 3.43551 16.8144 3.86301 16.3344 5.22051L13.3044 13.703C13.1919 13.988 12.8394 14.2355 12.5244 14.2355Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
